enum NotificationTypeEnum {
	Email = 0,
	Push = 1,
	Both = 2
}
export default NotificationTypeEnum
